module.exports = __webpack_public_path__ + "img/lomo.97268a69.png";